/**
 * Professional Wave Paint Worklet
 * 
 * Generates dynamic, multi-layered organic waves using procedural sine modulation.
 * Highly configurable for backgrounds, loaders, and artistic accents.
 */

class Wave {
  static get inputProperties() {
    return [
      '--fluent-wave-color',
      '--fluent-wave-amplitude',
      '--fluent-wave-frequency',
      '--fluent-wave-time',
      '--fluent-wave-layers'
    ];
  }

  paint(ctx: CanvasRenderingContext2D, size: { width: number; height: number }, props: any) {
    const color = props.get('--fluent-wave-color').toString() || 'rgba(0, 120, 212, 0.3)';
    const amplitude = parseFloat(props.get('--fluent-wave-amplitude')) || 20;
    const frequency = parseFloat(props.get('--fluent-wave-frequency')) || 0.01;
    const time = parseFloat(props.get('--fluent-wave-time')) || 0;
    const layers = parseInt(props.get('--fluent-wave-layers')) || 3;

    ctx.save();
    
    for (let i = 0; i < layers; i++) {
      const layerOffset = i * (Math.PI / layers);
      const layerAmplitude = amplitude * (1 - i * 0.2);
      const layerFrequency = frequency * (1 + i * 0.1);
      
      ctx.beginPath();
      ctx.moveTo(0, size.height);

      for (let x = 0; x <= size.width; x += 2) {
        // Procedural multi-sine wave generation
        const y = size.height / 2 + 
                 Math.sin(x * layerFrequency + time + layerOffset) * layerAmplitude +
                 Math.cos(x * layerFrequency * 0.5 - time * 0.5) * (layerAmplitude * 0.3);
        
        ctx.lineTo(x, y);
      }

      ctx.lineTo(size.width, size.height);
      ctx.closePath();

      // Slightly vary opacity per layer for depth
      ctx.globalAlpha = 1 / (i + 1);
      ctx.fillStyle = color;
      ctx.fill();
    }

    ctx.restore();
  }
}

registerPaint('fluent-wave', Wave);
